import React from "react";
import { useUscLabel, useUscOptionalLabel } from "../../../utils/labels";
import useExtrasBuyOrReserveLabels from "../../../hooks/useExtrasBuyOrReserveLabels";
import Banner from "../styles/molecules/Banner";
import Button from "../styles/atoms/Button";
import Text from "../styles/atoms/Text";
import { trackAemCustomerSupportClick } from "../../../utils/tracking";
import { useUscSelector } from "../../../redux/store";

const CustomerSupportBanner = (): JSX.Element | null => {
    const labelKeys = useExtrasBuyOrReserveLabels();
    const vehicleType = useUscSelector((state) => state.vehicle.type);
    const showCustomerSupportBanner = useUscSelector((state) => state.uscSettings.showCustomerSupportBanner);

    const [questionLabel, contactLabel, phoneNr, phoneNrLabel] = useUscLabel([
        labelKeys.extrasSupportQuestion,
        labelKeys.extrasSupportContact,
        labelKeys.extrasSupportPhoneNr,
        labelKeys.extrasSupportPhoneNrLabel,
    ]);

    const [questionDescriptionLabel, phoneNrDescriptionLabel] = useUscOptionalLabel([
        labelKeys.extrasSupportDescriptionQuestion,
        labelKeys.extrasSupportPhoneNrDescription,
    ]);

    if (!showCustomerSupportBanner) return null;

    return (
        <Banner variant="customer-support" title={questionLabel} description={questionDescriptionLabel}>
            <div>
                <Text tag="p" variant="body-semibold">
                    {contactLabel}
                </Text>
                <Button
                    variant="primary-dark"
                    href={`tel:${phoneNr}`}
                    onClick={() => trackAemCustomerSupportClick(vehicleType)}
                >
                    {phoneNrLabel}
                </Button>
            </div>
            <div>
                <Text tag="div" variant="body-small-book" color="grey-7">
                    {phoneNrDescriptionLabel}
                </Text>
            </div>
        </Banner>
    );
};

export default CustomerSupportBanner;
